import { Checkbox, Collapse, FormControl, FormControlLabel, Grid, InputLabel, ListItemText, MenuItem, Select, Typography } from "@mui/material"
import { use, useEffect, useState } from "react"
import { gql, useQuery } from "@apollo/client"
import { MultiSelectField, SelectField, SelectOption } from "ui"
import { Question } from "../../../../__generated__/graphql"
// import {GET_QUES}
export type SampleSlideInProps = {
    id?: string
}
const GET_ALL_QUESTIONS = gql(`
    query GetAllQuestions {
  allQuestions {
    id
    title
    type
    category
    questionSet
    language
    status
  }
}

`)
type QuestionSets = "ENGLISH_TWEEN_SCREEN" | "ENGLISH_T_SCREEN"
type QuestionType = "BOOLEAN" | "FREEFORM" | "MULTISELECT" | "COMPOSITE" | "SCALE"
type QuestionCategory = "ENVIRONMENT" | "PERSONAL" | "SURVEY"
function mapQuestionToSelect(question: Question) {
    return {
        label: question.title,
        value: question.id
    }
}
const SampleSlideIn = (props: SampleSlideInProps) => {
    const { loading, data } = useQuery(GET_ALL_QUESTIONS)
    const [filterOptions, setFilterOptions] = useState<{
        tScreenQuestions: SelectOption[],
        TweenScreenQuestions: SelectOption[],
        // displayOptions: SelectOption[]
    }>({
        tScreenQuestions: [],
        TweenScreenQuestions: [],
        // displayOptions: []
    })
    useEffect(() => {
        if (data) {
            const _tScreenQuestions = data.allQuestions.filter((e: any) => e.questionSet === "tScreen").map(mapQuestionToSelect);
            const _tweenScreenQuestions = data.allQuestions.filter((e: any) => e.questionSet === "TweenScreen").map(mapQuestionToSelect)
            setFilterOptions({
                tScreenQuestions: _tScreenQuestions,
                TweenScreenQuestions: _tweenScreenQuestions
            })

            // console.log(data)
        }
    }, [loading, data])
    const [searchCriteria, setSearchCriteria] = useState<{
        questionSets: QuestionSets[],
        questionIds: string[]
    }>({
        questionSets: [],
        questionIds: []
    })
    useEffect(() => {
        console.log("chanign the questionset: ", searchCriteria.questionSets)
    }, [searchCriteria.questionSets])
    const handleSelectQuestionSets = (event: any) => {
        const value = event.target.value
        const tScreenIds = filterOptions.tScreenQuestions.map((option: SelectOption) => option.value)
        const tweenScreenIds = filterOptions.TweenScreenQuestions.map((option: SelectOption) => option.value)
        let updatedQuestionIds = [...searchCriteria.questionIds]
        if (!value.includes("ENGLISH_TWEEN_SCREEN")) {
            updatedQuestionIds = updatedQuestionIds.filter((id) => !tweenScreenIds.includes(id))
        }
        if (!value.includes("ENGLISH_T_SCREEN")) {
            updatedQuestionIds = updatedQuestionIds.filter((id) => !tScreenIds.includes(id))

        }
        setSearchCriteria((prevState) => ({
            ...prevState,
            questionSets: event.target.value,
            questionIds: updatedQuestionIds
        }));


    }
    const handleSelectQuestionIds = (event: any) => {
        const value = event.target.value
        console.log("the value: ", value)
        const tScreenIds = filterOptions.tScreenQuestions.map((option: SelectOption) => option.value)
        const tweenScreenIds = filterOptions.TweenScreenQuestions.map((option: SelectOption) => option.value)
        const allIds = [...tScreenIds, ...tweenScreenIds]
        if (value.includes("allTWScreen")) {
            const allSelected = tweenScreenIds.every((id) =>
                searchCriteria.questionIds.includes(id)
            );

            setSearchCriteria((prevState) => ({
                ...prevState,
                questionIds: allSelected
                    ? prevState.questionIds.filter(
                        (id) => !tweenScreenIds.includes(id)
                    )
                    : [
                        ...new Set([
                            ...prevState.questionIds,
                            ...tweenScreenIds
                        ])
                    ]
            }));

            return;
        } else if (value.includes("allTScreen")) {
            console.log("here: ",)
            const allSelected = tScreenIds.every((id) =>
                searchCriteria.questionIds.includes(id)
            );

            setSearchCriteria((prevState) => ({
                ...prevState,
                questionIds: allSelected
                    ? prevState.questionIds.filter(
                        (id) => !tScreenIds.includes(id)
                    )
                    : [
                        ...new Set([
                            ...prevState.questionIds,
                            ...tScreenIds
                        ])
                    ]
            }));

            return;
        } else if (value.includes("selectAll")) {
            const allSelected = allIds.every((id) =>
                searchCriteria.questionIds.includes(id)
            );

            setSearchCriteria((prevState) => ({
                ...prevState,
                questionIds: allSelected ? [] : allIds
            }));

            return;
        } else {
            setSearchCriteria((prevState: any) => ({
                ...prevState,
                questionIds: event.target.value
            }
            ))
        }
    }
    const screenOptions: SelectOption[] = [
        { value: "ENGLISH_TWEEN_SCREEN", label: "English TweenScreen Questions" },
        { value: "ENGLISH_T_SCREEN", label: "English TScreen Questions" }]
    const questionTypeOptions: QuestionType[] = ["BOOLEAN", "FREEFORM", "MULTISELECT", "COMPOSITE", "SCALE"]
    useEffect(() => {
        console.log("the search critiera is changing: ", searchCriteria)
    }, [searchCriteria])
    return (
        <Grid container spacing={1.5}>
            <Grid size={12}>
                <Typography>What screen(s) would you like to review</Typography>
                <Typography sx={{ fontSize: "9px" }}>*This feature is only available for English Questions at the time*</Typography>
            </Grid>
            <Grid size={12}>
                <FormControl fullWidth variant="outlined">
                    <InputLabel id="selectQuestionSetLabel" required={true}>Select a question set(s)</InputLabel>
                    <Select
                        multiple
                        labelId="selectQuestionSetLabel"
                        value={searchCriteria.questionSets}
                        label="Select a question set(s)"
                        onChange={handleSelectQuestionSets}
                        renderValue={(selected) =>
                            selected
                                .map(
                                    (value) =>
                                        screenOptions.find((o) => o.value === value)?.label
                                )
                                .join(", ")
                        }>
                        {screenOptions.map((option: SelectOption) => (
                            <MenuItem key={option.value} value={option.value}>
                                <Checkbox checked={(searchCriteria.questionSets).includes(option.value as QuestionSets)} />
                                <ListItemText primary={option.label} />
                            </MenuItem>
                        ))}
                    </Select>
                </FormControl>
            </Grid>
            <Grid size={12}>
                <Collapse in={searchCriteria.questionSets.length > 0}>
                    <Grid container spacing={1.5}>

                        <Grid size={12}>
                            <Typography>Select the questions you want to examine</Typography>
                        </Grid>
                        <Grid size={12}>
                            <FormControl fullWidth variant="outlined">
                                <InputLabel id="selectQuestionsLabel" required={true}>Question(s)</InputLabel>
                                <Select
                                    multiple
                                    labelId="selectQuestionsLabel"
                                    value={searchCriteria.questionIds}
                                    label="Question(s)"
                                    onChange={handleSelectQuestionIds}
                                    renderValue={(selected) =>
                                        selected
                                            .map(
                                                (value) =>
                                                    filterOptions.tScreenQuestions.find((o) => o.value === value)?.label || filterOptions.TweenScreenQuestions.find((o) => o.value === value)?.label
                                            )
                                            .join(", ")
                                    }>
                                    {searchCriteria.questionSets.includes("ENGLISH_T_SCREEN") && searchCriteria.questionSets.includes("ENGLISH_TWEEN_SCREEN") ?
                                        <MenuItem sx={{ maxWidth: "400px" }} key={"selectAll"} value={"selectAll"}>
                                            <Checkbox checked={filterOptions.TweenScreenQuestions.length + filterOptions.tScreenQuestions.length == searchCriteria.questionIds.length} />
                                            <ListItemText
                                                sx={{
                                                    whiteSpace: "normal",
                                                    wordBreak: "break-word"
                                                }}
                                                primary={"Select All Questions"} />
                                        </MenuItem> :
                                        (searchCriteria.questionSets.includes("ENGLISH_T_SCREEN") ?
                                            (
                                                <MenuItem sx={{ maxWidth: "400px" }} value={"allTScreen"}>
                                                    <Checkbox checked={filterOptions.tScreenQuestions.every((option) => searchCriteria.questionIds.includes(option.value))} />
                                                    <ListItemText
                                                        sx={{
                                                            whiteSpace: "normal",
                                                            wordBreak: "break-word"
                                                        }}
                                                        primary={`Select all TScreen Questions`} />
                                                </MenuItem>
                                            ) : (<MenuItem sx={{ maxWidth: "400px" }} value={"allTWScreen"}>
                                                <Checkbox checked={filterOptions.TweenScreenQuestions.every((option) => searchCriteria.questionIds.includes(option.value))} />
                                                <ListItemText
                                                    sx={{
                                                        whiteSpace: "normal",
                                                        wordBreak: "break-word"
                                                    }}
                                                    primary={`Select all TweenScreen Questions`} />
                                            </MenuItem>))
                                    }
                                    {searchCriteria.questionSets.includes("ENGLISH_T_SCREEN") ?
                                        (
                                            filterOptions.tScreenQuestions.map((option: SelectOption) => (
                                                <MenuItem sx={{ maxWidth: "400px" }} key={option.value} value={option.value}>
                                                    <Checkbox checked={(searchCriteria.questionIds).includes(option.value as QuestionSets)} />
                                                    <ListItemText
                                                        sx={{
                                                            whiteSpace: "normal",
                                                            wordBreak: "break-word"
                                                        }}
                                                        primary={option.label} />
                                                </MenuItem>
                                            ))
                                        ) : <></>}
                                    {searchCriteria.questionSets.includes("ENGLISH_TWEEN_SCREEN") ?
                                        (
                                            filterOptions.TweenScreenQuestions.map((option: SelectOption) => (
                                                <MenuItem sx={{ maxWidth: "400px" }} key={option.value} value={option.value}>
                                                    <Checkbox checked={(searchCriteria.questionIds).includes(option.value as QuestionSets)} />
                                                    <ListItemText sx={{
                                                        whiteSpace: "normal",
                                                        wordBreak: "break-word"
                                                    }} primary={option.label} />
                                                </MenuItem>
                                            ))
                                        ) : <></>}
                                    {/* {screenOptions.map((option: SelectOption) => (
                                        <MenuItem key={option.value} value={option.value}>
                                            <Checkbox checked={(searchCriteria.questionSets).includes(option.value as QuestionSets)} />
                                            <ListItemText primary={option.label} />
                                        </MenuItem>
                                    ))} */}
                                </Select>
                            </FormControl>
                        </Grid>
                    </Grid>
                </Collapse>
            </Grid>
        </Grid >

    )
}

export default SampleSlideIn